import { environment as baseEnv } from './environment.dev'

export const environment = {
  ...baseEnv,
  environmentKey: 'dev-alt-8',
  apiUrl: 'https://dev-alt-8-api.eshyft.com/api/v2',
  socketUrl: 'https://dev-alt-8-api.eshyft.com',

  firebaseTenantId: 'dev-alt-8-ss2f7',
  verifyOtpUrl: 'https://verify-otp-lgtjqnr75q-uk.a.run.app'
}
